import { ClientNoteType } from '@/shared/client-note-type';

export interface ClientAccountNote {
    id?: string | null;
    type?: ClientNoteType | null;
    actioned?: boolean | null;
    text: string | null;
    version?: number;
    createdDate?: string | Date | null;
    createdBy?: string | null;
    lastModifiedDate?: string | Date | null;
    lastModifiedBy?: string | null;
}

export function createClientAccountNote(): ClientAccountNote {
    return {
        text: null,
    };
}
